import axios from 'axios';
import classNames from 'classnames';
import Button from 'components/base/Button';
import * as formik from 'formik';
import { Col, Form, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { goalProgressValidationSchema } from 'static/Patient';

const AddGoalProgress = ({ handleClose, goalId }: any) => {
  const { Formik } = formik;
  const { id } = useParams(); // Assuming you're using React Router for navigation
  const token = localStorage.getItem('token');
  const schema = goalProgressValidationSchema;
  const activeTab = location.pathname.includes('weight') ? 'weight' : 'hba1c';
  const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

  const onSubmit = async (values: any) => {
    const URL = `${process.env.REACT_APP_ENDPOINT}/clinic/goal-progress/patient/${id}`;
    const header = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    const data = {
      goal: values.goal,
      type: values.type,
      progress_value: values.progress_value,
      unit: values.unit,
      date: values.date
    };

    try {
      const response = await axios.post(URL, data, header);

      if (response.data.status === false) {
        toast.error(response.data.error.message);
        return;
      }

      toast(response.data.data.message);
      handleClose(true);
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  return (
    <Row>
      <Col xl={12}>
        <Formik
          validationSchema={schema}
          onSubmit={values => onSubmit(values)}
          initialValues={{
            goal: goalId || '',
            type: activeTab,
            progress_value: '',
            unit: activeTab === 'weight' ? 'kg' : 'ml',
            date: today
          }}
        >
          {({ handleSubmit, handleChange, values, touched, errors }) => {
            return (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Control type="hidden" name="goal" value={values.goal} />
                <Form.Control type="hidden" name="type" value={values.type} />
                <Form.Control type="hidden" name="unit" value={values.unit} />
                <Row className={classNames('g-3')}>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {activeTab === 'weight'
                          ? 'Current Weight (kg)'
                          : 'Current HbA1C (%)'}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="progress_value"
                        value={values.progress_value}
                        onChange={handleChange}
                        isValid={
                          touched.progress_value && !errors.progress_value
                        }
                        isInvalid={
                          touched.progress_value && !!errors.progress_value
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {' '}
                        {errors.progress_value}{' '}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="date"
                        value={values.date}
                        onChange={handleChange}
                        isValid={touched.date && !errors.date}
                        isInvalid={touched.date && !!errors.date}
                        max={today}
                      />
                      <Form.Control.Feedback type="invalid">
                        {' '}
                        {errors.date}{' '}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="text-end mt-3 mb-3">
                  <Button type="submit" variant="primary">
                    {activeTab === 'weight' ? 'Save Weight' : 'Save HbA1C'}
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Col>
    </Row>
  );
};

export default AddGoalProgress;
